var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebex = function SvgWebex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "58.17 111.5 396.5 289"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#webex_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__b)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__c)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__d)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__e)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__f)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__g)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__h)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__i)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__j)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__k)",
    d: "M330.571 111.5c-29.41 0-63.453 9.983-85.982 52.883-12.95 24.66-19.508 52.421-25.576 79.97-1.998 9.066-4.059 18.241-6.251 26.942v124.646c11.129-3.153 23.084-9.219 34.555-20.892 43.077-43.844 50.302-158.56 71.847-180.488 2.441-2.485 5.081-3.93 7.929-3.93 8.668 0 15.373 11.004 21.792 24.238 7.137 14.71 15.616 31.493 40.629 31.493 11.435 0 37.821-8.263 37.821-40.658 0-19.385-32.276-94.204-96.764-94.204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__l)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__m)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__n)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__o)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__p)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#316AFF",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__q)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__r)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__s)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__t)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__u)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__v)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__w)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__x)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__y)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__z)",
    d: "M415.439 155.647c-2.907 0-5.831.274-8.699.84 13.632 19.684 20.453 40.305 20.453 49.215 0 32.395-26.386 40.658-37.822 40.658-8.924 0-15.742-2.138-21.147-5.554l-.15.606c-1.608 6.43-2.876 13.466-5.072 20.314-4.222 13.166-9.917 28.206-15.999 39.844-6.555 12.546-13.045 19.887-20.781 19.502-8.797-.438-15.93-11.793-24.795-43.886-2.859-10.348-5.506-21.693-7.96-32.833-6.085-27.631-13.555-55.416-26.327-79.97-20.86-40.101-56.446-52.883-84.856-52.883-26.347 0-46.031 12.491-61.494 28.229-4.274 4.35-8.941 10.209-13.63 17.096 13.487 3.253 26.24 13.419 28.277 32.686.401 3.674 3.216 32.85 12.672 66.661 2.713-8.477 6.669-21.031 15.86-41.303 4.504-9.284 8.569-15.406 12.236-19.139 3.364-3.423 6.393-4.837 9.12-4.837 2.941 0 12.984 2.696 22.761 37.052 12.125 42.602 21.149 110.403 55.528 146.402 15.163 15.88 36.383 26.153 65.792 26.153 25.805 0 47.319-11.381 62.659-27.212 25.221-26.032 39.041-69.072 43.97-84.999 14.028-45.311 17.957-86.291 18.414-90.627 2.611-24.775-18.232-42.015-39.01-42.015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__A)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__B)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__C)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__D)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#webex_svg__E)",
    d: "M181.196 399.355c-73.419 0-98.407-92.978-104.006-111.066-14.061-45.42-18.336-86.333-18.788-90.627-2.611-24.775 17.232-42.015 39.01-42.015 16.49 0 35.628 9.884 38.163 33.866.44 4.034 3.792 38.823 15.652 76.73 12.376 39.562 25.506 54.776 34.961 54.776 15.269 0 24.585-39.272 32.821-76.666 6.068-27.549 12.627-55.31 25.576-79.97 22.529-42.9 56.572-52.883 85.982-52.883 64.488 0 96.764 74.819 96.764 94.204 0 32.395-26.385 40.658-37.821 40.658-25.013 0-33.492-16.783-40.629-31.493-6.419-13.234-13.124-24.238-21.792-24.238-2.848 0-5.488 1.445-7.929 3.93-21.545 21.928-28.769 136.644-71.847 180.488-23.882 24.306-49.867 24.306-66.117 24.306"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-120.825 179.778 73.144)scale(170.078 142.686)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#00717E",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#007281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-126.696 218.92 36.19)scale(138.687 91.0892)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#218970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#267E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026C51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-107.446 199.854 63.383)scale(112.995 58.8009)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#178697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#17838F",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#007281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-147.00185 -246.35344 75.9421 -45.3155 249.478 272.443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25342F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25342F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(85.105 21.49 281.97)scale(108.085 61.2215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#056C4E",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#056C4E",
    stopOpacity: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#056C4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(68.96185 106.65265 -55.90762 36.15 305.374 61.693)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#24BE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24BE82",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(49.689 -94.05 43.677)scale(165.848 165.397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BF7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(224.84618 250.16443 -249.7338 224.45914 132.847 3.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#00B9FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-107.446 169.277 72.734)scale(162.209 112.266)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCFF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#00BAFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-72.94808 -88.45534 61.91133 -51.05755 396.933 194.415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FEC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC08E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-79.109 352.692 -96.214)scale(34.7291 23.9896)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28855B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14795C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.00332 -27.99321 39.0727 8.37938 378.863 265.748)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28855B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14795C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-64.43135 -69.699 48.95906 -45.25888 412.925 214.168)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#5DE955",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(37.494 -164.075 685.348)scale(84.3935 117.347)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(98.43638 14.70715 -21.98144 147.12397 362.276 250.969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(24.693 -416.355 977.664)scale(85.0368 151.662)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(95.795 58.925 297.011)scale(153.04 83.7548)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#123AA8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.76398 183.80392 -65.50627 -4.19259 383.26 200.809)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.79566 97.3369 -51.49877 4.65359 174.818 239.104)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.88635 101.8839 -83.99975 4.02863 174.748 241.733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(104.42962 -44.76053 87.57453 204.31781 197.923 337.577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-70.50434 -26.35909 45.1806 -120.84742 157.506 216.794)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A3DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(137.44803 41.4221 -41.8633 138.912 91.26 242.448)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#123AA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(49.689 -94.047 43.665)scale(165.848 165.397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BF7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "webex_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-107.446 169.275 72.737)scale(162.209 112.266)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCFF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#00BAFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webex_svg__b",
    x1: 387.159,
    x2: 127.733,
    y1: 195.957,
    y2: 280.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CEE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webex_svg__i",
    x1: -39.386,
    x2: 144.414,
    y1: 252.916,
    y2: 254.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BF7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webex_svg__A",
    x1: 46.233,
    x2: 187.788,
    y1: 162.942,
    y2: 253.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#1DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CC1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webex_svg__C",
    x1: 54.051,
    x2: 93.775,
    y1: 167.56,
    y2: 203.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#0BF7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "webex_svg__D",
    x1: 43.511,
    x2: 98.388,
    y1: 195.127,
    y2: 199.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#0BF7F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "webex_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.17 111.5h396.5v289H58.17z"
  })))));
};
export default SvgWebex;